export const getBatteryStatus = async t => {
  let battery;
  try {
    const data = await navigator?.getBattery();
    battery = `${data.level * 100}%`;
  } catch {
    battery = t("global.notSupported");
  }
  return battery;
};
